// Internet Explorer 6-11
const isIE = /*@cc_on!@*/false || !!document.documentMode;
const isLoggingEnabled = true;
export function info(title, object, type) {
  let titleStyle = "";
  if (!isIE) {
    titleStyle = "border-radius: 4px; padding: 4px; font-weight: bold;";
    if (!type) {
      titleStyle = "".concat(titleStyle, " background-color: #5a5a5a; color: #fff;");
    } else if (type.toLowerCase() === "transmit") {
      titleStyle = "".concat(titleStyle, " font-family: roboto-bold,roboto,sans-serif; background-color: #eb690b; color: #fff;");
    } else if (type.toLowerCase() === "component") {
      titleStyle = "".concat(titleStyle, " font-family: roboto-bold,roboto,sans-serif; background-color: #006ace; color: #fff;");
    }
  }
  if (isLoggingEnabled) {
    if (isIE) {
      console.log(title, object);
    } else {
      console.log("%c".concat(title), titleStyle, object);
    }
  }
}
export function error(message, object) {
  const titleStyle = isIE ? "" : "border-radius: 4px; padding: 4px; font-weight: bold; background-color: #993131; color: #fff;";
  if (isLoggingEnabled) {
    if (isIE) {
      console.error("Error", message);
    } else {
      console.error("%cError", titleStyle, message);
    }
    if (object) {
      console.log(object);
    }
  }
}